import { RootState } from 'store/store';

export const selectBusinessUnitOptions = (state: RootState) => state.businessUnit.businessUnitOptions;
export const selectBusinessUnitsByRoleOptions = (state: RootState) => state.businessUnit.businessUnitByRoleOptions;
export const selectBusinessUnitStatus = (state: RootState) => state.businessUnit.businessUnitStatus;
